var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "手机:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.key_word_user,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "key_word_user", $$v)
                        },
                        expression: "form.key_word_user",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "昵称:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.key_word_nick,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "key_word_nick", $$v)
                        },
                        expression: "form.key_word_nick",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                      },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "order_table",
                staticClass: "ptd-5",
                attrs: {
                  id: "order_table",
                  data: _vm.list,
                  "max-height": _vm.tableMaxH,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "昵称", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-link", { staticClass: "cursor" }, [
                            _vm._v(
                              "【" +
                                _vm._s(scope.row.id) +
                                "】" +
                                _vm._s(scope.row.nick_name)
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "手机号码" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("div", [_vm._v(_vm._s(scope.row.phone))])]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "管理员类型" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.admin_type === 1
                            ? _c("div", [_vm._v("子平台管理员")])
                            : _c("div", [_vm._v("总后台")]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "ml-0",
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getAdminPermission(scope.row)
                                },
                              },
                            },
                            [_vm._v("PC端权限分配\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "ml-0",
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getMinPermission(scope.row)
                                },
                              },
                            },
                            [_vm._v("小程序权限分配\n            ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    limit: _vm.listQuery.limit,
                    "page-count": _vm.listQuery.page_num,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "PC端权限分配", visible: _vm.permissionDialog },
          on: {
            "update:visible": function ($event) {
              _vm.permissionDialog = $event
            },
          },
        },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.permissionMenu,
              "show-checkbox": "",
              "node-key": "id",
              "default-checked-keys": _vm.checkedKeys,
              props: _vm.defaultProps,
            },
            on: { "check-change": _vm.handleCheckChange },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.permissionDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setPermission()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "小程序权限分配", visible: _vm.permissionMinDialog },
          on: {
            "update:visible": function ($event) {
              _vm.permissionMinDialog = $event
            },
          },
        },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.permissionMenu,
              "show-checkbox": "",
              "node-key": "id",
              "default-checked-keys": _vm.checkedKeys,
              props: _vm.defaultProps,
            },
            on: { "check-change": _vm.handleCheckChange },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.permissionMinDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.setPermissionMin()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加管理员", visible: _vm.addAdminDialog },
          on: {
            "update:visible": function ($event) {
              _vm.addAdminDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "140px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "昵称：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.adminInfo.nick_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.adminInfo, "nick_name", $$v)
                      },
                      expression: "adminInfo.nick_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登录名：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.adminInfo.user_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.adminInfo, "user_name", $$v)
                      },
                      expression: "adminInfo.user_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.adminInfo.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.adminInfo, "phone", $$v)
                      },
                      expression: "adminInfo.phone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.adminInfo.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.adminInfo, "email", $$v)
                      },
                      expression: "adminInfo.email",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.adminInfo.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.adminInfo, "password", $$v)
                      },
                      expression: "adminInfo.password",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "权限类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.adminInfo.roles,
                        callback: function ($$v) {
                          _vm.$set(_vm.adminInfo, "roles", $$v)
                        },
                        expression: "adminInfo.roles",
                      },
                    },
                    _vm._l(_vm.rolesName, function (item) {
                      return _c(
                        "el-radio-button",
                        { attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addAdminDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitAdmin()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }